export default (theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: `${theme.color.white} !important`,
    fontWeight: 600,
  },
})
